import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  makeStyles,
  Drawer,
  Typography,
  TextField,
  Button,
  Tabs,
  Tab,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ControlPanelAdd from "./ControlPanelAdd";
import RoomIcon from "@material-ui/icons/Room";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
// store & actions
import { useSelector, useDispatch } from "react-redux";
import { markerActions } from "../../store/actions/marker.action";

const useStyles = makeStyles({
  list: {
    width: 250,
    padding: 20,
  },
  fullList: {
    width: "auto",
  },
  drawerPaper: {
    boxShadow:
      "0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12) ",
  },
  input: {
    marginBottom: "1em",
  },
});

export default function ControlPanel({ toggleDrawer, open }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const selectedMarker = useSelector((state) => state.marker.item);
  const loading = useSelector((state) => state.marker.loading);

  const [item, setItem] = useState({});
  const [openTab, setOpenTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setOpenTab(newValue);
  };

  useEffect(() => {
    const position = selectedMarker?.position;

    setItem({
      ...selectedMarker,
      latitude: position ? position[1] : "",
      longitude: position ? position[0] : "",
    });
  }, [selectedMarker]);

  const onFormSubmit = (e) => {
    e.preventDefault();
    const newLatitude = parseFloat(item.latitude);
    const newLongitude = parseFloat(item.longitude);

    const payload = {
      ...item,
      position: [newLongitude, newLatitude],
    };
    dispatch(markerActions.updateSelectedMarkerOnMap(payload));
  };

  const onDeleteMarker = (e) => {
    e.preventDefault();
    dispatch(markerActions.removeMarker(item.uniqueId));
  };

  const options = [
    "police",
    "army",
    "block",
    "water_tank",
    "medical_team",
    "stranger",
  ];

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
    >
      <Typography variant="h6" align="center" gutterBottom>
        Selected Marker <RoomIcon />
      </Typography>

      {item && Object.keys(item).length > 0 && (
        <React.Fragment>
          <Autocomplete
            value={item.type ?? ""}
            onChange={(event, newValue) => {
              setItem({ ...item, type: newValue });
            }}
            defaultValue={item.type}
            id="controllable-states-demo"
            options={options}
            fullWidth
            className={classes.input}
            renderInput={(params) => (
              <TextField {...params} label="Data Type" variant="outlined" />
            )}
          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Message"
            className={classes.input}
            value={item.message}
            onChange={(e) => setItem({ ...item, message: e.target.value })}
          />
          <TextField
            placeholder="Latitude"
            type="number"
            variant="outlined"
            fullWidth
            className={classes.input}
            style={{ marginBottom: "1rem" }}
            value={item.latitude}
            onChange={(e) => setItem({ ...item, latitude: e.target.value })}
          />
          <TextField
            placeholder="Longitude"
            type="number"
            variant="outlined"
            fullWidth
            className={classes.input}
            style={{ marginBottom: "1rem" }}
            value={item.longitude}
            onChange={(e) => setItem({ ...item, longitude: e.target.value })}
          />
          <span>
            Created at: {moment(item.createdAt).format("MMM DD, h:mm:ss a")}
          </span>
          <Button
            fullWidth
            variant="outlined"
            onClick={onFormSubmit}
            style={{ marginTop: 10 }}
          >
            Submit
          </Button>
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            onClick={onDeleteMarker}
            style={{ marginTop: 10 }}
            disabled={!item}
          >
            {loading ? "Loading..." : "Remove Marker"}
          </Button>

          <div
            style={{
              position: "absolute",
              bottom: 20,
              width: "80%",
            }}
          >
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={toggleDrawer("right", false)}
              style={{ marginTop: 10 }}
            >
              Close <CloseIcon />
            </Button>
          </div>
        </React.Fragment>
      )}
    </div>
  );

  return (
    <div>
      <Drawer
        anchor="right"
        open={open}
        variant="persistent"
        elevation={16}
        // onClose={toggleDrawer("right", false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Tabs
          value={openTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="New Data" {...a11yProps(0)} />
          <Tab label="Map Control" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={openTab} index={0}>
          <ControlPanelAdd toggleDrawer={toggleDrawer} />
        </TabPanel>
        <TabPanel value={openTab} index={1}>
          {list("right")}
        </TabPanel>
      </Drawer>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
